import { FormScaffoldProps } from "./types";
import { View, VStack } from "@gluestack-ui/themed";
import { ScrollView } from "@repo/core/components/layout/ScrollView";
import { KeyboardAvoidingView } from "@repo/core/components/core/KeyboardAvoidingView";
import { ScaffoldHeader } from "@repo/core/components/layout/Scaffolds/components/ScaffoldHeader";
import { Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { getFooterBottomPadding } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter/utils";

export const FormScaffold = ({
  showHeader,
  footerContent,
  centerFormContent = false,
  children,
  title,
  minHeight = "auto",
  footerOptions: _footerOptions,
  smWidth = "65%",
  mdWidth = "52%",
  ...rest
}: FormScaffoldProps) => {
  void _footerOptions;
  const insets = useSafeAreaInsets();
  const footerBottomPadding = getFooterBottomPadding(
    Platform.OS,
    insets.bottom,
    24
  );

  return (
    <View flex={1} minHeight={minHeight} w="$full" {...rest}>
      {showHeader && <ScaffoldHeader title={title} {...rest} />}
      <KeyboardAvoidingView flex={1} w="$full">
        <VStack flex={1} w="$full" alignItems="center" justifyContent="center">
          <VStack
            justifyContent="flex-start"
            flex={1}
            $web-md-w={mdWidth}
            $sm-w={smWidth}
            $base-w="$full"
          >
            <ScrollView
              keyboardShouldPersistTaps="handled"
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{
                flexGrow: 1,
                justifyContent: centerFormContent ? "center" : "flex-start",
                paddingBottom: 16
              }}
            >
              {children}
            </ScrollView>

            {footerContent ? (
              <VStack px="$4" pb={footerBottomPadding} gap="$4">
                {footerContent}
              </VStack>
            ) : null}
          </VStack>
        </VStack>
      </KeyboardAvoidingView>
    </View>
  );
};
